import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });

      if (res.ok) {
        const data = await res.json();
        localStorage.setItem("user_id", data.user.id);
        navigate("/admin/dashboard");
      } else {
        const data = await res.json();
        throw new Error(data.error);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray">
      <div className="w-full max-w-md p-8 space-y-6 bg-black rounded">
        <h2 className="text-2xl font-bold text-center text-orange">
          Admin Login
        </h2>
        <form onSubmit={handleLogin} className="space-y-4">
          <div className="form-group">
            <label className="block text-sm font-medium text-white-700">
              Username:
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring focus:border-blue-300 text-black"
            />
          </div>
          <div className="form-group">
            <label className="block text-sm font-medium text-white-700">
              Password:
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring focus:border-blue-300 text-black"
            />
          </div>
          <button
            type="submit"
            className="w-full px-4 py-2 text-white bg-orange rounded focus:outline-none focus:ring"
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
